import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/sub-comp/Navbar";
import Footer from "../components/sub-comp/MainFooter";

const NotFound = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <section className="py-20 text-center">
        <h1 className="text-5xl font-bold text-custom-pink mb-4">404</h1>
        <p className="text-gray-700 mb-6">The page you’re looking for doesn’t exist.</p>
        <Link to="/" className="px-6 py-3 rounded-full bg-custom-pink text-white hover:bg-purple-700 transition">Go Home</Link>
      </section>
      <Footer />
    </div>
  );
};

export default NotFound;



